// extracted by mini-css-extract-plugin
export default {"container":"goal-select_container__pyDeg","label":"goal-select_label__kH7EE"};